/** @deprecated Quarantined legacy (WEB-8485) — moved out of the Angular tree so the ReactTemplates.segment global survives Phase 6. Do not import in new code. */
import T from 'Components/Helpers/translate';
import { Feature, isAvailable } from 'App/services/FeatureHelperStandalone';
import { numberFormat } from 'Components/Filters/Currencies';
import AppService from 'App/legacy/AppService';
import { getConfig } from 'App/helpers/filterHelperInstances';
import { Tabs, Tab, Tooltip, Icon, Help } from '@upsales/components';
import FilterContainer from 'Components/segment/filterContainer';
import BouncingTooltip from 'Components/Tooltip/BouncingTooltip';
import {
	stopProp,
	accountHref as AccountHref,
	contactHref as ContactHref,
	leadStatus as LeadStatus,
	eventTypes as EventTypes
} from 'App/babel/components/LegacyReactTemplates';
import Paginator from 'App/babel/components/LegacyReactTemplates/paginator';

ReactTemplates.segment.formatError = function (error) {
	var t = T;

	if (error.errorCode === 106) {
		return t('default.error') + ': ' + t('segment.infiniteRecursivFilter');
	} else if (error.translated) {
		return t('default.error') + ': ' + error.translated;
	} else if (error.msg) {
		return t('default.error') + ': ' + error.msg;
	} else {
		return t('default.error') + ': ' + t('listError.default');
	}
};

ReactTemplates.segment.laodRow = function (colSpan) {
	return (
		<tr key={'laodRow'}>
			<td
				style={{ textAlign: 'center' }}
				colSpan={colSpan}
				className="segment-list-tbody-tr segment-list-loading"
			>
				<ReactTemplates.loader />
			</td>
		</tr>
	);
};

function getArticleId(error) {
	switch (error?.errorCode) {
		case 144:
			return 1274;
		default:
			return null;
	}
}

ReactTemplates.segment.errorRow = function (colSpan, message, error) {
	const articleId = getArticleId(error);

	return (
		<tr key={'errorRow'}>
			<td style={{ textAlign: 'center' }} colSpan={colSpan} className="segment-list-error segment-list-tbody-tr">
				{message}
				{articleId ? <Help articleId={articleId} /> : null}
			</td>
		</tr>
	);
};

ReactTemplates.segment.noResultRow = function (colSpan, message) {
	return (
		<tr key={'noResultRow'}>
			<td style={{ textAlign: 'center' }} colSpan={colSpan} className="segment-list-error segment-list-tbody-tr">
				{message}
			</td>
		</tr>
	);
};

ReactTemplates.segment.noResultRowPlaceholder = function (colSpan, img, title, description) {
	return (
		<tr key={'noResultRowPlaceholder'}>
			<td style={{ textAlign: 'center' }} colSpan={colSpan} className="segment-list-noresult-placeholder">
				<div style={{ maxWidth: '600px', margin: '0 auto' }}>
					{img ? <img src={img} /> : null}
					<h4>{T(title)}</h4>
					<p>{T(description)}</p>
				</div>
			</td>
		</tr>
	);
};

ReactTemplates.segment.statusBar = function (props) {
	var search = null;

	if (props.search && typeof props.search === 'object') {
		search = (
			<ReactTemplates.segment.tableSearch
				key={'search'}
				value={props.search.value}
				onChange={props.search.onChange}
				placeholder={props.search.placeholder || ''}
			/>
		);
	}

	return (
		<div className="segment-status-bar">
			{props.version === 2 ? (
				<div key={'stats'} className="segment-result-filter-container">
					<div className="segment-result-filters">
						<div
							className={
								'segment-result-filter total' + (props.activeTab === 'total' ? ' filter-active' : '')
							}
							onClick={props.changeTab.bind(null, 'total')}
						>
							<h4 className="filter-title">{props.segmentFilterNames.allContacts}</h4>
							<h5 className="filter-subtitle">{props.stats.total}</h5>
						</div>
						<div
							className={
								'segment-result-filter fromSelection' +
								(props.activeTab === 'fromSelection' ? ' filter-active' : '')
							}
							onClick={props.changeTab.bind(null, 'fromSelection')}
						>
							<h4 className="filter-title">{props.segmentFilterNames.fromCriterias}</h4>
							<h5 className="filter-subtitle">{props.stats.fromSelection}</h5>
						</div>
						<div
							className={
								'segment-result-filter manuallyIncluded' +
								(props.activeTab === 'manuallyIncluded' ? ' filter-active' : '')
							}
							onClick={props.changeTab.bind(null, 'manuallyIncluded')}
						>
							<h4 className="filter-title">{props.segmentFilterNames.manuallyIncluded}</h4>
							<h5 className="filter-subtitle">{props.stats.manuallyIncluded}</h5>
						</div>
						<div
							className={
								'segment-result-filter manuallyExcluded' +
								(props.activeTab === 'manuallyExcluded' ? ' filter-active' : '')
							}
							onClick={props.changeTab.bind(null, 'manuallyExcluded')}
						>
							<h4 className="filter-title">{props.segmentFilterNames.manuallyExcluded}</h4>
							<h5 className="filter-subtitle">{props.stats.manuallyExcluded}</h5>
						</div>
					</div>
				</div>
			) : null}
			{search}
		</div>
	);
};

ReactTemplates.segment.tableSearch = window.ReactCreateClass({
	timeout: null,
	getInitialState: function () {
		return { value: '' };
	},
	search: function (e) {
		var self = this;
		this.setState({ value: e.target.value });

		if (this.timeout) {
			clearTimeout(this.timeout);
			this.timeout = null;
		}

		this.timeout = setTimeout(function () {
			self.props.onChange(self.state.value);
		}, 200);
	},
	clear: function () {
		var self = this;
		this.setState({ value: '' }, function () {
			self.props.onChange(self.state.value);
		});
	},
	render: function () {
		return (
			<div className={this.state.value ? 'segment-list-search active' : 'segment-list-search'}>
				<b className="fa fa-search" />
				<b className="fa fa-times-circle" onClick={this.clear} />
				<input
					type="text"
					value={this.state.value || ''}
					onChange={this.search}
					placeholder={this.props.placeholder || ''}
				/>
			</div>
		);
	}
});

ReactTemplates.segment.renderTable = function (props) {
	var btn = null;

	if (props.headerButton) {
		var style = 'btn up-btn btn-green pull-right no-shadow';
		if (props.headerButton.disabled || !props.hasContacts) {
			style += ' disabled';
		}
		btn = (
			<button
				style={props.headerButton.disabled || !props.hasContacts ? { pointerEvents: 'auto' } : null}
				onClick={props.headerButton.disabled || !props.hasContacts ? _.noop : props.headerButton.onClick}
				className={style}
			>
				{props.headerButton.text}
			</button>
		);

		if (props.headerButton.disabled || (!props.hasContacts && props.id.indexOf('mailcampaign') !== -1)) {
			if (props.headerButton.tooltip) {
				btn = (
					<Tooltip title={props.headerButton.tooltip} position="left" key={props.id + '-tooltip'}>
						{btn}
					</Tooltip>
				);
			} else {
				btn = (
					<Tooltip title={props.infoNoSegment} position="left" key={props.id + '-tooltip'}>
						{btn}
					</Tooltip>
				);
			}
		}
	}
	return (
		<div id={props.id} className="segment-list">
			<div className="segment-list-title">
				{props.id === 'segment-contacts' ? (
					<ReactTemplates.segment.statusBar
						stats={props.stats}
						search={props.search}
						segmentFilterNames={props.segmentFilterNames}
						changeTab={props.changeTab}
						activeTab={props.activeTab}
						version={props.version}
					/>
				) : (
					<div className="email-campaigns">
						{props.hasEvents ? props.title : null}
						{props.buttons}
						{btn}
						{props.search && typeof props.search === 'object' ? (
							<ReactTemplates.segment.tableSearch
								value={props.search.value}
								onChange={props.search.onChange}
								placeholder={props.search.placeholder || ''}
							/>
						) : null}
					</div>
				)}
			</div>

			<table key={props.id} className="segment-list-table">
				<thead>{props.header}</thead>
				<tbody>{props.rows}</tbody>
			</table>
			{props.numberPages > 1 && !props.hidePaginator ? (
				<Paginator currentPage={props.currentPage} max={props.numberPages} onChange={props.paginatorChange} />
			) : (
				<div style={{ height: 100 }} />
			)}
		</div>
	);
};

ReactTemplates.segment.mailcampaign = window.ReactCreateClass({
	UNSAFE_componentWillMount: function () {
		var t = T;

		this.lang = {
			date: t('default.date'),
			status: t('default.status'),
			subject: t('groupMail.subject'),
			sent: t('event.sent'),
			click: t('event.contactclicks'),
			open: t('event.contactopen'),
			title: t('segment.mailcampaign.title'),
			sendOut: t('groupMail.newGroupMail'),
			noResult: t('noMatches.groupMail'),
			archive: t('default.archive'),
			unArchive: t('default.unArchive'),
			regularEmails: t('segment.regular.emails'),
			statuses: {
				ACTIVE: t('mail.status.ACTIVE'),
				ARCHIVED: t('mail.status.ARCHIVED'),
				DEL_PROJECT: t('mail.status.DEL_PROJECT'),
				DRAFT: t('mail.status.DRAFT'),
				ERROR: t('mail.status.ERROR'),
				ERROR_UNKNOWN: t('mail.status.ERROR_UNKNOWN'),
				MISSING_CREDITS: t('mail.status.MISSING_CREDITS'),
				MISSING_PAYMENT: t('mail.status.NO_CONTACTS'),
				NO_CONTACTS: t('mail.status.NO_CONTACTS'),
				PROCESSING: t('mail.status.PROCESSING'),
				SCHEDULED: t('mail.status.SCHEDULED'),
				SENT: t('mail.status.SENT')
			},
			infoNoSegment: t('segment.infoNoSegment'),
			cantSendGroupMail: t('segment.missing.contacts.cant.send.groupMail'),
			cantSendToArchived: t('segment.cantSendToArchived')
		};

		this.customerId = this.props.tools.AppService.getCustomerId();
	},
	header: function (regular) {
		return (
			<tr className="segment-list-thead-tr">
				{regular ? (
					<th style={{ width: 100 }} className="segment-list-thead-th">
						{this.lang.date}
					</th>
				) : null}
				{regular ? (
					<th style={{ width: 92 }} className="segment-list-thead-th">
						{this.lang.status}
					</th>
				) : null}
				<th className="segment-list-thead-th">{this.lang.subject}</th>
				<th style={{ width: 90 }} className="segment-list-thead-th">
					{this.lang.sent}
				</th>
				<th style={{ width: 100 }} className="segment-list-thead-th">
					{this.lang.open}
				</th>
				<th style={{ width: 90 }} className="segment-list-thead-th">
					{this.lang.click}
				</th>
				{regular ? <th style={{ width: 50 }} /> : null}
			</tr>
		);
	},
	rows: function (regular) {
		var self = this;
		var state = self.props.listState;
		var data = null;

		if (regular) {
			data = _.filter(state.data, function (row) {
				return !row.flowId;
			});
		} else {
			data = _.filter(state.data, function (row) {
				return !!row.flowId;
			});
		}

		return {
			events: data.length,
			data: data.map(function (mailCampaign) {
				var openMailCampaign = self.props.mailCampaignComponent.openMailCampaign.bind(self, mailCampaign);
				var archiveMailCampaign = self.props.mailCampaignComponent.archiveMailCampaign.bind(self, mailCampaign);
				var removeMailCampaign = self.props.mailCampaignComponent.removeMailCampaign.bind(self, mailCampaign);

				var momentDate = moment(mailCampaign.sendDate);
				var dateString = momentDate.isValid() ? momentDate.format('L') : '';
				var subjectString = mailCampaign.subject
					? mailCampaign.subject
					: mailCampaign.template
					? mailCampaign.template.name
					: '';

				return (
					<tr
						key={`mail-campaign-${mailCampaign.id}`}
						onClick={openMailCampaign}
						className={
							mailCampaign.isArchived
								? 'segment-list-tbody-tr segment-list-mailcampaign-archived'
								: 'segment-list-tbody-tr'
						}
					>
						{regular ? <td className="segment-list-tbody-td">{dateString}</td> : null}
						{regular ? (
							<td className="segment-list-tbody-td segment-ellipsis">
								<Tooltip title={self.lang.statuses[mailCampaign.status]} position="left" delay={250}>
									<span>{self.lang.statuses[mailCampaign.status]}</span>
								</Tooltip>
							</td>
						) : null}
						<td className="segment-list-tbody-td segment-ellipsis">
							<Tooltip title={subjectString} position="left" delay={250}>
								<span>{subjectString}</span>
							</Tooltip>
						</td>
						<td className="segment-list-tbody-td segment-ellipsis">{mailCampaign.mailSent}</td>
						<td className="segment-list-tbody-td segment-ellipsis">{mailCampaign.mailRead}</td>
						<td className="segment-list-tbody-td segment-ellipsis">{mailCampaign.mailClicked}</td>
						{regular ? (
							<td onClick={stopProp} className="segment-list-tbody-td segment-list-tools">
								{mailCampaign.status === 'SENT' && (
									<Tooltip
										title={mailCampaign.isArchived ? self.lang.unArchive : self.lang.archive}
										position="left"
										delay={250}
									>
										<i className="fa fa-archive" onClick={archiveMailCampaign} />
									</Tooltip>
								)}
								{(mailCampaign.status === 'DRAFT' ||
									mailCampaign.status === 'SCHEDULED' ||
									mailCampaign.status === 'ERROR' ||
									mailCampaign.status === 'NO_CONTACTS') && (
									<i className="fa fa-trash-o" onClick={removeMailCampaign} />
								)}
							</td>
						) : null}
					</tr>
				);
			})
		};
	},
	render: function () {
		var state = this.props.listState;
		var rows;
		var regularRows;
		var hasRows = {
			regular: 0,
			rows: 0
		};

		if (state.error) {
			var errorMessage = ReactTemplates.segment.formatError(state.error);
			rows = ReactTemplates.segment.errorRow(7, errorMessage, state.error);
			regularRows = ReactTemplates.segment.errorRow(7, errorMessage, state.error);
		} else if (state.loading) {
			rows = ReactTemplates.segment.laodRow(7);
			regularRows = ReactTemplates.segment.laodRow(7);
		} else if (this.props.listState.data.length === 0) {
			// rows = ReactTemplates.segment.noResultRow(7, this.lang.noResult);
			rows = [];
			regularRows = ReactTemplates.segment.noResultRowPlaceholder(
				7,
				'img/empty-briefcase.png',
				'segment.noMatches.groupMail.title',
				'segment.noMatches.groupMail.desc'
			);
		} else {
			var _rows = this.rows();
			var _regularRows = this.rows(true);

			rows = _rows.data;
			regularRows = _regularRows.data;

			hasRows.regular = _regularRows.events;
			hasRows.rows = _rows.events;
		}

		var hasSelection = _.some(this.props.segment.filter, { isExclude: false });

		if (this.props.listState.data.length === 0) {
			return (
				<div>
					{ReactTemplates.segment.renderTable({
						id: 'segment-mailcampaign',
						title: this.lang.regularEmails,
						paginatorChange: this.props.paginatorChange,
						rows: regularRows,
						hasContacts: this.props.totalContacts,
						hasEvents: hasRows.regular > 0,
						currentPage: this.props.listState.currentPage,
						numberPages: this.props.listState.numberPages,
						headerButton: {
							text: this.lang.sendOut,
							onClick: this.props.mailCampaignComponent.newMailCampaign,
							disabled: !hasSelection || !this.props.segment.active,
							tooltip: !this.props.segment.active
								? this.lang.cantSendToArchived
								: this.lang.cantSendGroupMail
						},
						infoNoSegment: this.lang.infoNoSegment,
						stats: this.props.filterSelection.state.stats,
						changeTab: this.props.filterSelection.changeTab,
						activeTab: this.props.filterSelection.state.activeTab,
						version: this.props.segment.version
					})}
				</div>
			);
		}

		return (
			<div>
				{regularRows.length &&
					ReactTemplates.segment.renderTable({
						id: 'segment-mailcampaign',
						title: this.lang.regularEmails,
						paginatorChange: this.props.paginatorChange,
						rows: regularRows,
						hasContacts: this.props.totalContacts,
						hasEvents: hasRows.regular > 0,
						header: this.header(true),
						currentPage: this.props.listState.currentPage,
						numberPages: this.props.listState.numberPages,
						headerButton: {
							text: this.lang.sendOut,
							onClick: this.props.mailCampaignComponent.newMailCampaign,
							disabled: !hasSelection || !this.props.segment.active,
							tooltip: !this.props.segment.active
								? this.lang.cantSendToArchived
								: this.lang.cantSendGroupMail
						},
						infoNoSegment: this.lang.infoNoSegment,
						stats: this.props.filterSelection.state.stats,
						changeTab: this.props.filterSelection.changeTab,
						activeTab: this.props.filterSelection.state.activeTab,
						version: this.props.segment.version
					})}

				{!!rows.length &&
					ReactTemplates.segment.renderTable({
						id: regularRows.length > 0 ? 'segment-mailcampaign-second' : 'segment-mailcampaign',
						title: this.lang.title,
						paginatorChange: this.props.paginatorChange,
						rows: rows,
						hasContacts: this.props.totalContacts,
						hasEvents: hasRows.rows > 0,
						header: this.header(),
						currentPage: this.props.listState.currentPage,
						numberPages: this.props.listState.numberPages,
						headerButton:
							regularRows.length > 0
								? null
								: {
										text: this.lang.sendOut,
										onClick: this.props.mailCampaignComponent.newMailCampaign,
										disabled: !hasSelection || !this.props.segment.active,
										tooltip: !this.props.segment.active
											? this.lang.cantSendToArchived
											: this.lang.cantSendGroupMail
								  },
						infoNoSegment: this.lang.infoNoSegment,
						stats: this.props.filterSelection.state.stats,
						changeTab: this.props.filterSelection.changeTab,
						activeTab: this.props.filterSelection.state.activeTab,
						version: this.props.segment.version
					})}
			</div>
		);
	}
});

ReactTemplates.segment.contacts = window.ReactCreateClass({
	UNSAFE_componentWillMount: function () {
		var t = T;

		this.lang = {
			title: t('segment.contacts.title'),
			name: t('default.name'),
			email: t('default.email'),
			added: t('segment.contacts.added'),
			dynamic: t('segment.contacts.dynamicallyAdded'),
			noResult: t('noMatches.contact'),
			today: t('date.today'),
			search: t('default.search'),
			editContact: t('default.editContact'),
			excludeContact: t('segment.excludeContactFromSegment'),
			segmentFilters: {
				allContacts: t('segment.filter.allContacts'),
				fromCriterias: t('segment.filter.fromCriterias'),
				manuallyIncluded: t('segment.filter.manuallyIncluded'),
				manuallyExcluded: t('segment.filter.manuallyExcluded')
			},
			removeContactManuallyIncluded: t('segment.removeContactManuallyIncluded'),
			removeContactManuallyExcluded: t('segment.removeContactManuallyExcluded'),
			contactIsExcluded: t('segment.contactIsExcluded'),
			unsubscribed: t('default.unsubscribedFromGroupMail'),
			unsubscribedFrom: t('default.unsubscribedFrom')
		};

		this.customerId = this.props.tools.AppService.getCustomerId();
	},
	shouldComponentUpdate: function (newProps) {
		var oldProps = this.props;
		var oldStats = oldProps.filterSelection.state.stats;
		var newStats = newProps.filterSelection.state.stats;

		if (
			newProps.listState !== oldProps.listState ||
			oldProps.listState.error !== newProps.listState.error ||
			oldProps.contactComponent.filterStr !== newProps.contactComponent.filterStr ||
			oldProps.contactComponent.currentSort !== newProps.contactComponent.currentSort ||
			oldProps.filterSelection.state.activeTab !== newProps.filterSelection.state.activeTab ||
			oldStats !== newStats
		) {
			return true;
		}
		return false;
	},
	rows: function () {
		var self = this;
		var state = self.props.listState;
		var tools = self.props.tools;
		var segment = self.props.segment;
		var version = segment.version;
		var contactComponent = self.props.contactComponent;

		return state.data.map(function (contact) {
			var editContact = contactComponent.editContact.bind(self, contact);
			var excludeContactFromSegment = contactComponent.excludeContactFromSegment.bind(self, contact);
			var removeContactFromManuallyIncluded = contactComponent.removeContactFromManuallyIncluded.bind(
				self,
				contact.id
			);
			var removeContactFromManuallyExcluded = contactComponent.removeContactFromManuallyExcluded.bind(
				self,
				contact.id
			);

			var contactSegment = _.find(contact.segments, function (contactSegment) {
				return contactSegment.id === segment.id;
			});

			var excludeComponent = null;
			var emailCol = null;

			if (version === 2) {
				switch (self.props.filterSelection.state.activeTab) {
					case 'total':
						excludeComponent = (
							<Tooltip
								title={self.lang.excludeContact}
								position="left"
								key={'exclude-contact-list-' + contact.id}
							>
								<i onClick={excludeContactFromSegment} className="Icon Icon-times-circle" />
							</Tooltip>
						);
						break;
					case 'fromSelection':
						var isExcluded = contactComponent.isContactManuallyExcluded(contact.id);

						if (isExcluded) {
							excludeComponent = (
								<Tooltip
									title={self.lang.removeContactManuallyExcluded}
									position="left"
									key={'exclude-contact-list-' + contact.id}
								>
									<i onClick={removeContactFromManuallyExcluded} className="Icon Icon-plus-circle" />
								</Tooltip>
							);
						} else {
							excludeComponent = (
								<Tooltip
									title={self.lang.excludeContact}
									position="left"
									key={'exclude-contact-list-' + contact.id}
								>
									<i onClick={excludeContactFromSegment} className="Icon Icon-times-circle" />
								</Tooltip>
							);
						}

						break;
					case 'manuallyIncluded':
						excludeComponent = (
							<Tooltip
								title={self.lang.removeContactManuallyIncluded}
								position="left"
								key={'exclude-contact-list-' + contact.id}
							>
								<i onClick={removeContactFromManuallyIncluded} className="Icon Icon-times-circle" />
							</Tooltip>
						);

						break;
					case 'manuallyExcluded':
						excludeComponent = (
							<Tooltip
								title={self.lang.removeContactManuallyExcluded}
								position="left"
								key={'exclude-contact-list-' + contact.id}
							>
								<i onClick={removeContactFromManuallyExcluded} className="Icon Icon-plus-circle" />
							</Tooltip>
						);

						break;
				}
				let iconColor = null;
				let tooltip = null;

				var hasIcon = false;
				if (contact.unsubscribed) {
					hasIcon = true;
					iconColor = 'red';
					tooltip = `${self.lang.unsubscribed} ${moment(contact.unsubscribed).format('L')}`;
				} else if (!contact.unsubscribed && contact.optOut && contact.optOut.length) {
					hasIcon = true;
					iconColor = 'orange';
					tooltip = `${self.lang.unsubscribedFrom}:\n${contact.optOut.map(cat => `${cat.title}\n`).join('')}`;
				}

				var icon = null;
				if (hasIcon) {
					const i = <Icon name="minus-circle" color={iconColor} space="mrs" />;
					icon = tooltip ? (
						<Tooltip position="left" title={tooltip}>
							{i}
						</Tooltip>
					) : (
						i
					);
				}

				emailCol = (
					<span>
						{icon}
						{contact.email}
					</span>
				);
			} else {
				excludeComponent = (
					<Tooltip
						title={self.lang.excludeContact}
						position="left"
						key={'exclude-contact-list-' + contact.id}
					>
						<i onClick={excludeContactFromSegment} className="fa fa-times-circle" />
					</Tooltip>
				);

				emailCol = contact.email;
			}

			return (
				<tr className="segment-list-tbody-tr" key={`contact-${contact.id}`}>
					<td className="segment-list-tbody-td">
						<div key="contact" className="segment-ellipsis">
							<ContactHref
								customerId={self.customerId}
								id={contact.id}
								text={contact.name}
								tools={tools}
							/>
						</div>
						{contact.client ? (
							<div key="account" className="segments-contacts-client segment-ellipsis">
								<AccountHref
									customerId={self.customerId}
									id={contact.client.id}
									text={contact.client ? contact.client.name : '-'}
									tools={tools}
								/>
							</div>
						) : null}
					</td>
					<td className="segment-list-tbody-td segment-ellipsis">{emailCol}</td>
					<td className="segment-list-tbody-td segment-ellipsis">{`${contact.score ? contact.score : 0} (${
						contact.marketScoreMonth ? contact.marketScoreMonth : 0
					})`}</td>
					<td className="segment-list-tbody-td segment-ellipsis">
						<LeadStatus
							theKey={contact.id}
							tools={tools}
							activity={contact.hasActivity}
							activityOld={contact.hadActivity}
							appointment={contact.hasAppointment}
							appointmentOld={contact.hadAppointment}
							opportunity={contact.hasOpportunity}
							opportunityOld={contact.hadOpportunity}
							order={contact.hasOrder}
							orderOld={contact.hadOrder}
							isContact
						/>
					</td>
					<td className="segment-list-tbody-td segment-ellipsis">
						<EventTypes account={contact} theKey="marketActivity" tools={tools} />
					</td>
					{self.props.filterSelection.state.activeTab !== 'manuallyExcluded' ? (
						<td className="segment-list-tbody-td segment-contacts-added">
							<div>
								{contactSegment !== undefined
									? moment(contactSegment.date).format('L LT')
									: self.lang.today}
							</div>
						</td>
					) : null}
					<td className="segment-list-tbody-td segment-list-tools">
						<Tooltip title={self.lang.editContact} position="left" key={'edit-contact-list-' + contact.id}>
							<i onClick={editContact} className="fa fa-pencil-square-o" />
						</Tooltip>
						{excludeComponent}
					</td>
				</tr>
			);
		});
	},
	getThClass: function (key, sortable) {
		var c = 'segment-list-thead-th';
		if (sortable) {
			c += ' sortable-th';
		}
		if (sortable && key === this.props.contactComponent.currentSort.attr) {
			c += ' sorted';
		}
		return c;
	},
	setSort: function (key) {
		var self = this;
		return function () {
			self.props.contactComponent.setSort(key);
		};
	},
	getSortIndicator: function (key, numeric) {
		var className = 'fa';
		if (key === this.props.contactComponent.currentSort.attr) {
			if (this.props.contactComponent.currentSort.asc) {
				className += numeric ? ' fa-sort-numeric-asc' : ' fa-sort-alpha-asc';
			} else {
				className += numeric ? ' fa-sort-numeric-desc' : ' fa-sort-alpha-desc';
			}
		} else {
			className += ' fa-sort';
		}
		return <b className={className} />;
	},
	header: function () {
		var self = this;
		return (
			<tr className="segment-list-thead-tr">
				<th className={this.getThClass('name', true)} onClick={self.setSort('name')}>
					{this.lang.name}
					{this.getSortIndicator('name')}
				</th>
				<th className={this.getThClass('email', true)} onClick={self.setSort('email')}>
					{this.lang.email}
					{this.getSortIndicator('email')}
				</th>
				<th
					style={{ width: '120px' }}
					className={this.getThClass('score', true)}
					onClick={self.setSort('score')}
				>
					<Tooltip title={T('default.marketEvent90Days')} position="top">
						<span>{T('default.scoreTotal')}</span>
					</Tooltip>
					{this.getSortIndicator('score', true)}
				</th>
				<th style={{ width: '110px' }} className={this.getThClass('history', false)}>
					<Tooltip title={T('column.history')} position="top">
						<span>{T('default.history')}</span>
					</Tooltip>
				</th>
				<th style={{ width: '120px' }} className={this.getThClass('marketHistory', false)}>
					<Tooltip title={T('column.marketHistory')} position="top">
						<span>{T('default.market')}</span>
					</Tooltip>
				</th>
				{self.props.filterSelection.state.activeTab !== 'manuallyExcluded' ? (
					<th style={{ width: '120px' }} className={this.getThClass('segment.date', false)}>
						{this.lang.added}
					</th>
				) : null}
				<th style={{ width: '70px' }} />
			</tr>
		);
	},
	render: function () {
		var state = this.props.listState;
		var rows,
			header = null;

		if (state.error) {
			header = this.header();
			var errorMessage = ReactTemplates.segment.formatError(state.error);
			rows = ReactTemplates.segment.errorRow(7, errorMessage, state.error);
		} else if (state.loading) {
			header = this.header();
			rows = ReactTemplates.segment.laodRow(7);
		} else if (
			this.props.hasActiveSelection(this.props.segment.filter) &&
			this.props.listState.data.length === 0 &&
			this.props.contactComponent.filterStr
		) {
			rows = ReactTemplates.segment.noResultRowPlaceholder(7, null, 'segment.filter.list.noMatches.search', '');
		} else if (this.props.listState.data.length === 0) {
			rows = ReactTemplates.segment.noResultRowPlaceholder(
				7,
				null,
				'segment.filter.list.includeNoMatches',
				'segment.filter.list.includeNoMatchesList'
			);
		} else {
			header = this.header();
			rows = this.rows();
		}

		return ReactTemplates.segment.renderTable({
			id: 'segment-contacts',
			title: this.lang.title,
			paginatorChange: this.props.paginatorChange,
			rows: rows,
			header: header,
			currentPage: this.props.listState.currentPage,
			numberPages: this.props.listState.numberPages,
			segmentFilterNames: this.lang.segmentFilters,
			search: {
				value: this.props.contactComponent.filterStr,
				onChange: this.props.contactComponent.filterContacts,
				placeholder: this.lang.search
			},
			stats: this.props.filterSelection.state.stats,
			changeTab: this.props.filterSelection.changeTab,
			activeTab: this.props.filterSelection.state.activeTab,
			version: this.props.segment.version
		});
	}
});

ReactTemplates.segment.filtersList = window.ReactCreateClass({
	UNSAFE_componentWillMount: function () {
		var t = T;

		this.lang = {
			include: {
				title: t('segment.filter.list.includeTitle'),
				subtitle: t('segment.filter.list.includeSubtitle'),
				noMatches: t('segment.filter.list.includeNoMatches'),
				noMatchesExplanation: t('segment.filter.list.includeNoMatchesExplanation'),
				addButtonText: t('segment.filter.list.addButtonText')
			},
			exclude: {
				title: t('segment.filter.list.excludeTitle'),
				subtitle: t('segment.filter.list.excludeSubtitle'),
				noMatches: t('segment.filter.list.excludeNoMatches'),
				noMatchesExplanation: t('segment.filter.list.excludeNoMatchesExplanation'),
				addButtonText: t('segment.filter.list.addButtonText')
			},
			contacts: t('default.contacts2'),
			type: t('default.type'),
			total: t('default.total'),
			activeFilter: t('filters.activeFilters'),
			selected: t('default.selected'),
			clickToAdd: t('segment.clickToAddTooltip'),
			yes: t('default.yes'),
			no: t('default.no')
		};
	},
	createInfoTooltip: function (config) {
		var self = this;
		var $translate = T;
		var result = [<h6 key="activeFilter">{self.lang.activeFilter}</h6>];

		_.each(config, function (filter, name) {
			var value;
			var conf;

			if (filter.dataType !== 'list') {
				if (_.isBoolean(filter.value)) {
					if (filter.value) {
						value = self.lang.yes;
					} else {
						value = self.lang.no;
					}
				} else if (filter.dataType === 'range') {
					if (filter.value.start && !filter.value.end) {
						value = '> ' + filter.value.start;
					}

					if (!filter.value.start && filter.value.end) {
						value = '< ' + filter.value.end;
					}

					if (filter.value.start && filter.value.end) {
						value = filter.value.start + ' - ' + filter.value.end;
					}
				} else {
					if (filter.comparisonType === 'NotEquals') {
						value = $translate('default.not') + ' ' + filter.value;
					} else {
						value = filter.value;
					}
				}
			} else {
				if (filter.comparisonType === 'NotEquals') {
					value =
						$translate('default.not') + ' ' + filter.value.length + ' ' + self.lang.selected.toLowerCase();
				} else {
					value = filter.value.length + ' ' + self.lang.selected.toLowerCase();
				}
			}

			if (filter.dataType === 'Date' || filter.dataType === 'dateRange') {
				conf = getConfig(name, 'contact');
				if (!conf) {
					return;
				}

				if (value.preset === 'custom') {
					if (value.start && !value.end) {
						result.push(
							<div key={name + '_' + value.preset + '_' + value.start}>
								{$translate(conf.title)}
								{':'} {'> ' + moment(value.start).format('L')}
							</div>
						);
					} else if (!value.start && value.end) {
						result.push(
							<div key={name + '_' + value.preset + '_' + value.start}>
								{$translate(conf.title)}
								{':'} {'< ' + moment(value.end).format('L')}
							</div>
						);
					} else {
						result.push(
							<div key={name + '_' + value.preset + '_' + value.start}>
								{$translate(conf.title)}
								{':'} {$translate('default.between')} {moment(value.start).format('L')} {'-'}{' '}
								{moment(value.end).format('L')}
							</div>
						);
					}
				} else {
					result.push(
						<div key={name + '_' + value.preset}>
							{$translate(conf.title)}
							{':'} {$translate('date.' + value.preset)}
						</div>
					);
				}
			}

			if (name === 'ExcludeId') {
				result.push(<div key={name + '_' + value}>{$translate('segment.manual.exclude')}</div>);
			}

			if (name === 'IncludeId' || name === 'Id') {
				result.push(<div key={name + '_' + value}>{$translate('segment.manual.include')}</div>);
			}

			if (name === 'AddressFiltersClient') {
				_.forEach(filter.value, function (obj, key) {
					if (key === 'Zipcode') {
						if (obj.value.start && obj.value.end) {
							result.push(
								<div key={key + '_' + obj.value.start + '-' + obj.value.end}>
									{$translate('address.zip')}
									{':'} {obj.value.start + ' - ' + obj.value.end}
								</div>
							);
						}

						if (obj.value.start && !obj.value.end) {
							result.push(
								<div key={key + '_' + obj.value.start}>
									{$translate('address.zip')}
									{':'} {$translate('segment.date.over')} {obj.value.start}
								</div>
							);
						}

						if (!obj.value.start && obj.value.end) {
							result.push(
								<div key={key + '_' + obj.value.end}>
									{$translate('address.zip')}
									{':'} {$translate('segment.date.below')} {obj.value.end}
								</div>
							);
						}
					} else {
						if (obj.value && obj.value.length) {
							if (obj.comparisonType === 'NotEquals') {
								result.push(
									<div key={key + '_' + obj.value}>
										{$translate('address.' + key.toLowerCase())}
										{':'} {$translate('default.not')} {obj.value}
									</div>
								);
							} else {
								result.push(
									<div key={key + '_' + obj.value}>
										{$translate('address.' + key.toLowerCase())}
										{':'} {obj.value}
									</div>
								);
							}
						}
					}
				});
			}

			if (
				name !== 'ExcludeId' &&
				name !== 'IncludeId' &&
				name !== 'Id' &&
				name !== 'AddressFiltersClient' &&
				filter.dataType !== 'Date' &&
				filter.dataType !== 'dateRange'
			) {
				conf = getConfig(name, 'contact');
				if (!conf) {
					return;
				}
				result.push(
					<div key={name + '_' + value}>
						{$translate(conf.title)}
						{':'} {value}
					</div>
				);
			}
		});
		return result;
	},

	render: function () {
		var self = this;
		var exclude = self.props.exclude;
		var segment = self.props.segment;
		var lang = exclude ? this.lang.exclude : this.lang.include;
		var $translate = T;

		var classes = 'segment-filters-list';
		if (exclude) {
			classes = classes + ' exclude';
		}
		if (segment.filter.length) {
			classes = classes + ' has-filters';
		}

		var filters = _.filter(segment.filter, function (filter) {
			return exclude ? filter.isExclude : !filter.isExclude;
		});

		var rows = _.map(filters, function (filter, index) {
			var removeFilter = self.props.removeFilter.bind(self, filter);
			var editFilter = self.props.editFilter.bind(self, filter);
			var nrFilters = Object.keys(filter.config).length;
			var nrFiltersString = $translate(
				nrFilters === 1 ? 'segment.filters.nrFiltersSingular' : 'segment.filters.nrFiltersPlural',
				{ count: nrFilters }
			);
			var contactsString = filter.$$nrMatchingContacts
				? self.props.tools.formatNumber(filter.$$nrMatchingContacts)
				: 0;
			var info = self.createInfoTooltip(filter.config);
			var filterName = (
				<Tooltip title={info} position="right">
					<a
						data-test-id={'segment-edit-selection-' + index}
						className="segment-hover-cursor-pointer"
						onClick={editFilter}
					>
						{$translate('segment.dynamicSelection')}
						{': '}
						{nrFiltersString.toLowerCase()}
					</a>
				</Tooltip>
			);

			return (
				<tr className="segment-fl-tr">
					<td className="segment-fl-td">{filterName}</td>
					<td className="segment-fl-td">{contactsString}</td>
					<td className="segment-fl-td">
						<i onClick={removeFilter} className="fa fa-trash segment-hover-cursor-pointer" />
					</td>
				</tr>
			);
		});

		var excludedContacts = {
			count: 0,
			list: []
		};
		_.each(segment.filter, function (filter) {
			if (self.props.exclude && filter.config.ExcludeId) {
				excludedContacts.count += filter.config.ExcludeId.value.length;
				excludedContacts.list.push(filter.config.ExcludeId.value);
			}
		});

		if (excludedContacts.count > 0) {
			var flattenedExcludeList = _.flatten(excludedContacts.list);

			var excludedContactsFilter = new self.props.tools.RequestBuilder();
			excludedContactsFilter.addFilter(
				self.props.tools.Contact.attr.id,
				excludedContactsFilter.comparisonTypes.Equals,
				flattenedExcludeList
			);

			var excludeFilterConfig = {};

			excludeFilterConfig['Id'] = getConfig('Id', 'contact');
			excludeFilterConfig['Id'].value = flattenedExcludeList;

			var excludeFilter = {
				body: {
					q: excludedContactsFilter.build().q
				},
				config: excludeFilterConfig,
				isExclude: true,
				manualExcluded: true
			};

			var editManualExcludedContacts = self.props.editFilter.bind(self, excludeFilter);

			rows.push(
				<tr className="segment-fl-tr">
					<td className="segment-fl-td">
						<span style={{ color: '#4A90E2', cursor: 'pointer' }} onClick={editManualExcludedContacts}>
							<i className="up-icon-unassigned-user" style={{ marginRight: '5px' }} />
							{$translate('segment.manual.excluded.contacts')}
						</span>
					</td>
					<td className="segment-fl-td">{self.props.tools.formatNumber(excludedContacts.count)}</td>
					<td className="segment-fl-td">
						<i
							onClick={self.props.removeExcludedContacts.bind(self, filters)}
							className="fa fa-trash segment-hover-cursor-pointer"
						/>
					</td>
				</tr>
			);
		}

		return (
			<div
				className={classes}
				data-test-id={'segment-edit-selectionsection-' + (exclude ? 'exclude' : 'include')}
			>
				<div className="segment-fl-header">
					<button
						onClick={self.props.addFilter.bind(self, exclude)}
						data-test-id={'segment-edit-add-selection'}
						className="btn up-btn no-shadow btn-sm segment-fl-addbutton"
					>
						{lang.addButtonText}
					</button>
					{!exclude && !segment.filter.length && (
						<div id="segment-bouncy-tooltip">{self.lang.clickToAdd}</div>
					)}
					<div className="segment-fl-titlerow">
						<i
							className={
								exclude ? 'fa fa-minus-circle segment-fl-icon' : 'fa fa-plus-circle segment-fl-icon'
							}
						/>
						{lang.title}
					</div>
					<div className="segment-fl-subtitle">{lang.subtitle}</div>
				</div>
				{rows.length ? (
					<div className="segment-fl-body">
						<table className="segment-fl-table">
							<thead className="segment-fl-thead">
								<tr className="segment-fl-tr">
									<th className="segment-fl-th">{self.lang.type}</th>
									<th colSpan={2} className="segment-fl-th">
										{self.lang.contacts}
									</th>
								</tr>
							</thead>
							<tbody className="segment-fl-tbody">{rows}</tbody>
						</table>
					</div>
				) : (
					<div className="segment-fl-body">
						<div className="segment-fl-noMatch">{lang.noMatches}</div>
						<div className="segment-fl-noMatchExplanation">{lang.noMatchesExplanation}</div>
					</div>
				)}
			</div>
		);
	}
});

ReactTemplates.segment.filters = window.ReactCreateClass({
	UNSAFE_componentWillMount: function () {
		var t = T;

		this.lang = {
			edit: t('segment.filter.button.closed'),
			hide: t('segment.filter.button.open')
		};
	},
	render: function () {
		var self = this;
		var state = self.props.filterComponent.state;
		var segment = self.props.segment;
		var tools = self.props.tools;

		var closedText =
			segment.filter.length === 1
				? tools.$translate('segment.filter.closed.singular', { nrFilters: 1 })
				: tools.$translate('segment.filter.closed.plural', { nrFilters: segment.filter.length });

		var includeFilterList = React.createElement(ReactTemplates.segment.filtersList, {
			exclude: false,
			segment: segment,
			addFilter: self.props.filterComponent.addFilter,
			removeFilter: self.props.actions.removeFilter,
			removeExcludedContacts: self.props.actions.removeExcludedContacts,
			editFilter: self.props.filterComponent.editFilter,
			tools: tools
		});

		var excludeFilterList = React.createElement(ReactTemplates.segment.filtersList, {
			exclude: true,
			segment: segment,
			addFilter: self.props.filterComponent.addFilter,
			removeFilter: self.props.actions.removeFilter,
			removeExcludedContacts: self.props.actions.removeExcludedContacts,
			editFilter: self.props.filterComponent.editFilter,
			tools: tools
		});

		return (
			<div id="segment-filters" className={state.expanded ? 'expanded' : ''}>
				<div className="child-holder">
					<div className={state.expanded ? 'in-active' : 'active'}>
						<div className="segment-filters-unexpanded-text">
							<i className="fa fa-refresh" /> <span dangerouslySetInnerHTML={{ __html: closedText }} />
						</div>
					</div>
					<div className={state.expanded ? 'active' : 'in-active'}>
						<div className="segment-filters-titlerow">
							<span className="segment-filters-title">{self.lang.edit}</span>
							<button
								onClick={self.props.filterComponent.toggleExpand}
								className="segment-filters-titlebutton btn-link"
							>
								{self.lang.hide}
							</button>
						</div>
						{includeFilterList}
						{excludeFilterList}
					</div>
				</div>
				<button
					data-test-id="segment-edit-show-filters"
					onClick={self.props.filterComponent.toggleExpand}
					className="segment-filters-button btn-link"
				>
					{state.expanded ? self.lang.hide : self.lang.edit}
					<div className="segments-filters-button-shadow-element" />
				</button>
			</div>
		);
	}
});

ReactTemplates.segment.body = window.ReactCreateClass({
	UNSAFE_componentWillMount: function () {
		var t = T;

		this.lang = {
			contacts: t('default.contacts2'),
			mailcampaign: t('default.mailing'),
			events: t('default.events'),
			flows: t('default.flows'),
			nothingToSee_title: t('segment.nothingToSee.title'),
			nothingToSee_description: t('segment.nothingToSee.description'),
			nothingToSee_buttonTxt: t('segment.nothingToSee.buttonTxt'),
			nothingToSee_contacts_title: t('segment.nothingToSee.contacts.title'),
			nothingToSee_contacts_desc1: t('segment.nothingToSee.contacts.desc1'),
			nothingToSee_contacts_desc2: t('segment.nothingToSee.contacts.desc2'),
			selectionTooltip: t('flow.selectionTooltip')
		};
	},
	createSVG: function () {
		return {
			__html: '<?xml version="1.0" encoding="UTF-8"?><svg width="269px" height="405px" viewBox="0 0 269 392" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <!-- Generator: sketchtool 46.2 (44496) - http://www.bohemiancoding.com/sketch --> <title>C9282C44-FB83-4EFD-A6D4-2A4F0DED2FA9</title> <desc>Created with sketchtool.</desc> <defs> <polygon id="path-1" points="86.6266343 86.6266343 225.670094 39 192.185595 192.185595 39 225.670094"></polygon> <ellipse id="path-3" cx="26" cy="7.5" rx="26" ry="7.5"></ellipse> <ellipse id="path-5" cx="24" cy="6.5" rx="24" ry="6.5"></ellipse> </defs> <g id="Segments" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="2-Pick-contact---Onboarding" transform="translate(-365.000000, -197.000000)"> <g id="Mask-+-Segment-illustration-+-Så-fungerar-urval-+-Med-urval-lägger-du-+-Button-/-Bright-Blue-/-Filled-Icon-left-/-Small-Mask" transform="translate(340.000000, 169.000000)"> <g id="Segment-illustration" transform="translate(20.000000, -16.000000)"> <polygon id="Mask" fill="#000000" opacity="0.049999997" transform="translate(141.995689, 361.995689) rotate(-315.000000) translate(-141.995689, -361.995689) " points="96.2872765 316.287276 235.330736 268.660642 201.846237 421.846237 48.6606422 455.330736"></polygon> <g id="Group-2" transform="translate(0.000000, 150.000000)"> <polygon id="Rectangle-23-Copy-2" fill="#2EAA9B" transform="translate(136.993534, 137.493534) rotate(-315.000000) translate(-136.993534, -137.493534) " points="227.148124 40.9780304 233.509037 47.3389431 202.145858 202.645858 46.8389431 234.009037 40.4780304 227.648124"></polygon> <g id="Rectangle-23-Copy-3" transform="translate(5.000000, 0.000000)"> <mask id="mask-2" fill="white"> <use xlink:href="#path-1"></use> </mask> <use id="Mask" fill="#E8F8F6" transform="translate(132.335047, 132.335047) rotate(-315.000000) translate(-132.335047, -132.335047) " xlink:href="#path-1"></use> <polygon fill="#2EAA9B" opacity="0.200000018" mask="url(#mask-2)" transform="translate(133.497845, 113.248922) rotate(-315.000000) translate(-133.497845, -113.248922) " points="86.5154376 66.2665153 216.581367 30.1653996 185.998007 165.749085 50.4143219 196.332445"></polygon> </g> </g> <rect id="Rectangle" fill="#4A90E2" opacity="0.100000001" x="115" y="138" width="52" height="169"></rect> <ellipse id="Oval-3" fill="#E8F8F6" cx="141" cy="307" rx="26" ry="9"></ellipse> <g id="girl" transform="translate(131.000000, 243.000000)"> <polyline id="Path-6" stroke="#2EAA9B" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" points="14 43 14 56 14 62"></polyline> <polyline id="Path-6-Copy" stroke="#2EAA9B" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" points="7 43 7 56 7 62"></polyline> <path d="M10.5,0 L10.5,0 L10.5,0 C14.7180299,-7.7483953e-16 18.2113007,3.27516099 18.4828671,7.48443982 L19.7426581,27.0112011 L19.7426581,27.0112011 C19.8493302,28.6646178 18.5954458,30.0914518 16.942029,30.1981238 C16.659048,30.2163807 16.3749076,30.1944239 16.0980908,30.1329091 L11,29 L4.83384418,30.2332312 L4.83384418,30.2332312 C3.20916492,30.558167 1.6286896,29.5045168 1.30375375,27.8798375 C1.2523327,27.6227323 1.23483901,27.3599953 1.25171985,27.0983423 L2.51713292,7.48443982 L2.51713292,7.48443982 C2.78869929,3.27516099 6.28197006,7.7483953e-16 10.5,0 Z" id="Rectangle-16" fill="#2EAA9B"></path> <path d="M10.5,29 L10.5,29 L10.5,29 C14.7077799,29 18.1826195,32.2871513 18.4160251,36.4884526 L18.9300295,45.7405318 L18.9300295,45.7405318 C18.9606648,46.2919662 18.5384736,46.7638269 17.9870392,46.7944622 C17.9103491,46.7987227 17.8334235,46.7941336 17.7577839,46.7807854 L2.88369031,44.1559453 L2.88369031,44.1559453 C2.38093386,44.0672236 2.02573088,43.6140369 2.05969048,43.1046428 L2.50110742,36.4833887 L2.50110742,36.4833887 C2.78184929,32.2722607 6.27952434,29 10.5,29 Z" id="Rectangle-13" fill="#50E3C2"></path> <path d="M10,18 L11,18 L11,18 C16.5228475,18 21,22.4771525 21,28 L21,37 L21,37 C21,38.1045695 20.1045695,39 19,39 L2,39 L2,39 C0.8954305,39 1.3527075e-16,38.1045695 0,37 L0,28 L0,28 C-6.76353751e-16,22.4771525 4.4771525,18 10,18 Z" id="Rectangle-13" fill="#50E3C2"></path> <path d="M8,18 L13,18 L11.4946184,32.4516633 L11.4946184,32.4516633 C11.4373983,33.0009759 10.9457065,33.3998957 10.3963939,33.3426756 C9.9260846,33.293685 9.55437214,32.9219726 9.50538159,32.4516633 L8,18 Z" id="Rectangle-19" fill="#2EAA9B"></path> <path d="M4,6 C5.33333333,7.33333333 6.66666667,8 8,8 C9.33333333,8 12.3333333,7.66666667 17,7 L17,9.5 L17,9.5 C17,13.0898509 14.0898509,16 10.5,16 L10.5,16 L10.5,16 C6.91014913,16 4,13.0898509 4,9.5 L4,6 Z" id="Rectangle-16" fill="#DDF0EC"></path> <rect id="Rectangle-17" fill="#01687D" x="8" y="9" width="1" height="1" rx="0.5"></rect> <rect id="Rectangle-17-Copy" fill="#01687D" x="12" y="9" width="1" height="1" rx="0.5"></rect> <path d="M18,38 L21,38 L21,41.5 L21,41.5 C21,42.3284271 20.3284271,43 19.5,43 L19.5,43 L19.5,43 C18.6715729,43 18,42.3284271 18,41.5 L18,38 Z" id="Rectangle-14-Copy-3" fill="#DDF0EC"></path> <path d="M-6.88106798e-14,38 L3,38 L3,39 L3,39 C3,40.6568542 1.65685425,42 -6.86269753e-14,42 L-6.88106798e-14,42 L-6.88106798e-14,38 Z" id="Rectangle-14-Copy-4" fill="#DDF0EC" transform="translate(1.500000, 40.000000) scale(-1, 1) translate(-1.500000, -40.000000) "></path> </g> <rect id="Rectangle" fill="#4A90E2" opacity="0.100000001" x="157" y="105" width="52" height="169"></rect> <ellipse id="Oval-3" fill="#E8F8F6" cx="183" cy="274" rx="26" ry="8"></ellipse> <g id="girl" transform="translate(173.000000, 209.000000)"> <path d="M14,44 L13,63" id="Path-6" stroke="#002F65" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M7,44 L7.5,61" id="Path-6-Copy" stroke="#002F65" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M10.5,30 L10.5,30 L10.5,30 C14.7202243,30 18.2174467,33.2725594 18.4972445,37.4834984 L18.9410912,44.1633638 L18.9410912,44.1633638 C18.9746903,44.6690274 18.624713,45.1198818 18.1265133,45.2127347 L3.25149068,47.9850957 L3.25149068,47.9850957 C2.70855523,48.0862864 2.18638787,47.7281814 2.08519723,47.185246 C2.07057718,47.1068026 2.06539856,47.0268912 2.06977186,46.9472169 L2.5889458,37.4887272 L2.5889458,37.4887272 C2.81952059,33.2880361 6.29298559,30 10.5,30 Z" id="Rectangle-13" fill="#002F65"></path> <path d="M10,17 L11,17 L11,17 C16.5228475,17 21,21.4771525 21,27 L21,29.5 L21,29.5 C21,35.2989899 16.2989899,40 10.5,40 L10.5,40 L10.5,40 C4.70101013,40 2.48652828e-15,35.2989899 1.77635684e-15,29.5 L0,27 L0,27 C-6.76353751e-16,21.4771525 4.4771525,17 10,17 Z" id="Rectangle-13" fill="#002F65"></path> <path d="M12.5,35 L13.0574682,34.6283545 L13.0574682,34.6283545 C13.5169969,34.3220021 14.1378663,34.4461759 14.4442187,34.9057046 C14.4672194,34.9402056 14.4880519,34.9761038 14.5065956,35.0131912 L16,38 L14.7102631,38.4299123 L14.7102631,38.4299123 C13.7005104,38.7664965 12.5904078,38.3856118 12,37.5 L12,37.5 L12,37.5 C11.4477153,36.6715729 11.6715729,35.5522847 12.5,35 Z" id="Rectangle-20" fill="#E4EDF7"></path> <path d="M5.02924647,34.8615214 L6.52924647,33.8615214 L8.01360486,36.8302382 L8.01360486,36.8302382 C8.26059411,37.3242167 8.06036976,37.9248897 7.56639127,38.171879 C7.52406798,38.1930406 7.48029606,38.2111715 7.43540544,38.2261351 L7.02924647,38.3615214 L7.02924647,38.3615214 C6.1436347,38.6567253 5.17001039,38.3226673 4.65218845,37.5459344 L4.52924647,37.3615214 L4.52924647,37.3615214 C3.97696172,36.5330943 4.20081935,35.4138062 5.02924647,34.8615214 Z" id="Rectangle-20" fill="#E4EDF7" transform="translate(6.172838, 36.164726) rotate(-120.000000) translate(-6.172838, -36.164726) "></path> <path d="M10.5,-5.42101086e-20 L10.5,-5.42101086e-20 L10.5,0 C14.6421356,-7.60893085e-16 18,3.35786438 18,7.5 L18,15 L18,15 C18,15.5522847 17.5522847,16 17,16 L4,16 L4,16 C3.44771525,16 3,15.5522847 3,15 L3,7.5 L3,7.5 C3,3.35786438 6.35786438,7.60893085e-16 10.5,0 Z" id="Rectangle-16" fill="#4A90E2"></path> <path d="M5.26642848,6.42383723 C6.65605667,6.80794574 8.23391384,7 10,7 C11.9191471,7 13.8428112,6.77321377 15.7709924,6.3196413 L15.7709868,6.31961762 C16.3086107,6.19315058 16.8469627,6.52645901 16.9734297,7.06408284 C16.991084,7.139133 17,7.21597302 17,7.29307166 L17,11 L17,11 C17,13.7614237 14.7614237,16 12,16 L9,16 L9,16 C6.23857625,16 4,13.7614237 4,11 L4,7.38772247 L3.99997056,7.38772247 C3.99997056,6.83542146 4.44769899,6.38769302 5,6.38769302 C5.09003161,6.38769302 5.1796509,6.39985095 5.26642848,6.42383723 Z" id="Rectangle-16" fill="#E4EDF7"></path> <rect id="Rectangle-17" fill="#01687D" x="8" y="9" width="1" height="1" rx="0.5"></rect> <rect id="Rectangle-17-Copy" fill="#01687D" x="12" y="9" width="1" height="1" rx="0.5"></rect> </g> <g id="platou"> <polygon id="Rectangle-23-Copy" fill="#4A90E2" transform="translate(136.993534, 137.493534) rotate(-315.000000) translate(-136.993534, -137.493534) " points="227.148124 40.9780304 233.509037 47.3389431 202.145858 202.645858 46.8389431 234.009037 40.4780304 227.648124"></polygon> <polygon id="Rectangle-23" fill="#E0EAF4" transform="translate(136.995689, 131.995689) rotate(-315.000000) translate(-136.995689, -131.995689) " points="91.2872765 86.2872765 230.330736 38.6606422 196.846237 191.846237 43.6606422 225.330736"></polygon> <g id="Oval-2" transform="translate(114.000000, 165.000000)"> <mask id="mask-4" fill="white"> <use xlink:href="#path-3"></use> </mask> <use id="Mask" fill="#4A90E2" xlink:href="#path-3"></use> <ellipse fill="#FFFFFF" mask="url(#mask-4)" cx="26" cy="15.5" rx="26" ry="7.5"></ellipse> </g> <g id="Oval-2-Copy-6" transform="translate(160.000000, 113.000000)"> <mask id="mask-6" fill="white"> <use xlink:href="#path-5"></use> </mask> <use id="Mask" fill="#4A90E2" xlink:href="#path-5"></use> <ellipse id="Oval-2" fill="#FFFFFF" mask="url(#mask-6)" cx="24" cy="14.5" rx="24" ry="6.5"></ellipse> </g> </g> <g id="girl" transform="translate(91.000000, 88.000000)"> <ellipse id="Oval-2-Copy" fill-opacity="0.200000003" fill="#01687D" cx="12" cy="66.5" rx="12" ry="3.5"></ellipse> <polyline id="Path-6" stroke="#01687D" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" points="16 44 16 57 16 63"></polyline> <polyline id="Path-6-Copy" stroke="#01687D" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" points="9 44 9 57 9 63"></polyline> <path d="M12.5,30 L12.5,30 L12.5,30 C16.7044144,30 20.1732121,33.2910305 20.3941912,37.4896337 L20.9560756,48.1654364 L20.9560756,48.1654364 C20.9815032,48.6485615 20.6574303,49.0806046 20.1864971,49.1914124 L5.28545701,52.6975395 L5.28545701,52.6975395 C4.74785355,52.8240345 4.20949544,52.4907652 4.08300051,51.9531617 C4.06200726,51.8639404 4.05338015,51.7722565 4.05736152,51.6806851 L4.67422082,37.4929212 L4.67422082,37.4929212 C4.85638844,33.3030658 8.30618631,30 12.5,30 Z" id="Rectangle-13" fill="#2EAA9B"></path> <path d="M12,17 L13,17 L13,17 C18.5228475,17 23,21.4771525 23,27 L23,38 L23,38 C23,39.1045695 22.1045695,40 21,40 L4,40 L4,40 C2.8954305,40 2,39.1045695 2,38 L2,27 L2,27 C2,21.4771525 6.4771525,17 12,17 Z" id="Rectangle-13" fill="#2EAA9B"></path> <path d="M12.5,-5.42101086e-20 L12.5,-5.42101086e-20 L12.5,0 C16.6421356,-7.60893085e-16 20,3.35786438 20,7.5 L20,15 L20,15 C20,15.5522847 19.5522847,16 19,16 L6,16 L6,16 C5.44771525,16 5,15.5522847 5,15 L5,7.5 L5,7.5 C5,3.35786438 8.35786438,7.60893085e-16 12.5,0 Z" id="Rectangle-16" fill="#01687D"></path> <path d="M7.26642848,6.42383723 C8.65605667,6.80794574 10.2339138,7 12,7 C13.9191471,7 15.8428112,6.77321377 17.7709924,6.3196413 L17.7709868,6.31961762 C18.3086107,6.19315058 18.8469627,6.52645901 18.9734297,7.06408284 C18.991084,7.139133 19,7.21597302 19,7.29307166 L19,11 L19,11 C19,13.7614237 16.7614237,16 14,16 L11,16 L11,16 C8.23857625,16 6,13.7614237 6,11 L6,7.38772247 L5.99997056,7.38772247 C5.99997056,6.83542146 6.44769899,6.38769302 7,6.38769302 C7.09003161,6.38769302 7.1796509,6.39985095 7.26642848,6.42383723 Z" id="Rectangle-16" fill="#F6F9FB"></path> <rect id="Rectangle-17" fill="#01687D" x="10" y="9" width="1" height="1" rx="0.5"></rect> <rect id="Rectangle-17-Copy" fill="#01687D" x="14" y="9" width="1" height="1" rx="0.5"></rect> <path d="M20,39 L23,39 L23,41 L23,41 C23,42.6568542 21.6568542,44 20,44 L20,44 L20,39 Z" id="Rectangle-14-Copy-3" fill="#E4EDF7"></path> <path d="M2,39 L5,39 L5,40 L5,40 C5,41.6568542 3.65685425,43 2,43 L2,43 L2,39 Z" id="Rectangle-14-Copy-4" fill="#E4EDF7" transform="translate(3.500000, 41.000000) scale(-1, 1) translate(-3.500000, -41.000000) "></path> </g> <g id="guy" transform="translate(38.000000, 69.000000)"> <path d="M13.5,17 L13.5,17 L13.5,17 C17.0898509,17 20,19.9101491 20,23.5 L20,46 L7,46 L7,23.5 L7,23.5 C7,19.9101491 9.91014913,17 13.5,17 Z" id="Rectangle-13" fill="#002F65"></path> <ellipse id="Oval-2-Copy-3" fill-opacity="0.200000003" fill="#01687D" cx="13" cy="67.5" rx="13" ry="3.5"></ellipse> <path d="M17,44 L18,65" id="Path-6" stroke="#002F65" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M10,44 L8,65" id="Path-6-Copy-2" stroke="#002F65" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13,17 L14,17 L14,17 C19.5228475,17 24,21.4771525 24,27 L24,29 L24,29 C24,33.9705627 19.9705627,38 15,38 L12,38 L12,38 C7.02943725,38 3,33.9705627 3,29 L3,27 L3,27 C3,21.4771525 7.4771525,17 13,17 Z" id="Rectangle-13" fill="#002F65"></path> <path d="M11.044423,17 L13,17 L14.955577,17 L14.955577,17 C15.5078618,17 15.955577,17.4477153 15.955577,18 C15.955577,18.0144842 15.9552623,18.0289667 15.9546332,18.0434372 L15.0415897,39.0434372 L15.0415897,39.0434372 C15.0183338,39.5783234 14.577925,40 14.0425335,40 L11.9574665,40 L11.9574665,40 C11.422075,40 10.9816662,39.5783234 10.9584103,39.0434372 L10.0453668,18.0434372 L10.0453668,18.0434372 C10.0213771,17.4916737 10.4492223,17.0249336 11.0009858,17.0009438 C11.0154563,17.0003147 11.0299388,17 11.044423,17 Z" id="Rectangle-14-Copy" fill="#FFFFFF"></path> <path d="M12,0 L19,0 L19,0 C19.5522847,-1.08250786e-15 20,0.44771525 20,1 L20,7.5 L20,7.5 C20,11.0898509 17.0898509,14 13.5,14 L13.5,14 L13.5,14 C9.91014913,14 7,11.0898509 7,7.5 L7,5 L7,5 C7,2.23857625 9.23857625,5.07265313e-16 12,0 Z" id="Rectangle-16" fill="#002F65"></path> <path d="M13.5,1 L13.5,1 L13.5,1 C17.0898509,1 20,3.91014913 20,7.5 L20,9.5 L20,9.5 C20,13.0898509 17.0898509,16 13.5,16 L13.5,16 L13.5,16 C9.91014913,16 7,13.0898509 7,9.5 L7,7.5 L7,7.5 C7,3.91014913 9.91014913,1 13.5,1 Z" id="Rectangle-16" fill="#F6F9FB"></path> <rect id="Rectangle-17" fill="#002F65" x="10" y="9" width="1" height="1" rx="0.5"></rect> <rect id="Rectangle-17-Copy" fill="#002F65" x="16" y="9" width="1" height="1" rx="0.5"></rect> <path d="M13,17 L13,17 L13,17 C13.2838445,17 13.5215083,17.2150828 13.5497519,17.4975186 L15,32 L13,33 L11,32 L12.4502481,17.4975186 L12.4502481,17.4975186 C12.4784917,17.2150828 12.7161555,17 13,17 Z" id="Rectangle-18" fill="#002F65"></path> </g> <g id="girl" transform="translate(128.000000, 64.000000)"> <ellipse id="Oval-2-Copy-4" fill-opacity="0.200000003" fill="#01687D" cx="12" cy="65.5" rx="12" ry="3.5"></ellipse> <path d="M16,44 L15,63" id="Path-6" stroke="#002F65" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M9,44 L9.5,61" id="Path-6-Copy" stroke="#002F65" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12.5,30 L12.5,30 L12.5,30 C16.7202243,30 20.2174467,33.2725594 20.4972445,37.4834984 L20.9410912,44.1633638 L20.9410912,44.1633638 C20.9746903,44.6690274 20.624713,45.1198818 20.1265133,45.2127347 L5.25149068,47.9850957 L5.25149068,47.9850957 C4.70855523,48.0862864 4.18638787,47.7281814 4.08519723,47.185246 C4.07057718,47.1068026 4.06539856,47.0268912 4.06977186,46.9472169 L4.5889458,37.4887272 L4.5889458,37.4887272 C4.81952059,33.2880361 8.29298559,30 12.5,30 Z" id="Rectangle-13" fill="#002F65"></path> <path d="M12,17 L13,17 L13,17 C18.5228475,17 23,21.4771525 23,27 L23,29.5 L23,29.5 C23,35.2989899 18.2989899,40 12.5,40 L12.5,40 L12.5,40 C6.70101013,40 2,35.2989899 2,29.5 L2,27 L2,27 C2,21.4771525 6.4771525,17 12,17 Z" id="Rectangle-13" fill="#002F65"></path> <path d="M14.5,35 L15.0574682,34.6283545 L15.0574682,34.6283545 C15.5169969,34.3220021 16.1378663,34.4461759 16.4442187,34.9057046 C16.4672194,34.9402056 16.4880519,34.9761038 16.5065956,35.0131912 L18,38 L16.7102631,38.4299123 L16.7102631,38.4299123 C15.7005104,38.7664965 14.5904078,38.3856118 14,37.5 L14,37.5 L14,37.5 C13.4477153,36.6715729 13.6715729,35.5522847 14.5,35 Z" id="Rectangle-20" fill="#E4EDF7"></path> <path d="M7.02924647,34.8615214 L8.52924647,33.8615214 L10.0136049,36.8302382 L10.0136049,36.8302382 C10.2605941,37.3242167 10.0603698,37.9248897 9.56639127,38.171879 C9.52406798,38.1930406 9.48029606,38.2111715 9.43540544,38.2261351 L9.02924647,38.3615214 L9.02924647,38.3615214 C8.1436347,38.6567253 7.17001039,38.3226673 6.65218845,37.5459344 L6.52924647,37.3615214 L6.52924647,37.3615214 C5.97696172,36.5330943 6.20081935,35.4138062 7.02924647,34.8615214 Z" id="Rectangle-20" fill="#E4EDF7" transform="translate(8.172838, 36.164726) rotate(-120.000000) translate(-8.172838, -36.164726) "></path> <path d="M12.5,-5.42101086e-20 L12.5,-5.42101086e-20 L12.5,0 C16.6421356,-7.60893085e-16 20,3.35786438 20,7.5 L20,15 L20,15 C20,15.5522847 19.5522847,16 19,16 L6,16 L6,16 C5.44771525,16 5,15.5522847 5,15 L5,7.5 L5,7.5 C5,3.35786438 8.35786438,7.60893085e-16 12.5,0 Z" id="Rectangle-16" fill="#4A90E2"></path> <path d="M7.26642848,6.42383723 C8.65605667,6.80794574 10.2339138,7 12,7 C13.9191471,7 15.8428112,6.77321377 17.7709924,6.3196413 L17.7709868,6.31961762 C18.3086107,6.19315058 18.8469627,6.52645901 18.9734297,7.06408284 C18.991084,7.139133 19,7.21597302 19,7.29307166 L19,11 L19,11 C19,13.7614237 16.7614237,16 14,16 L11,16 L11,16 C8.23857625,16 6,13.7614237 6,11 L6,7.38772247 L5.99997056,7.38772247 C5.99997056,6.83542146 6.44769899,6.38769302 7,6.38769302 C7.09003161,6.38769302 7.1796509,6.39985095 7.26642848,6.42383723 Z" id="Rectangle-16" fill="#E4EDF7"></path> <rect id="Rectangle-17" fill="#01687D" x="10" y="9" width="1" height="1" rx="0.5"></rect> <rect id="Rectangle-17-Copy" fill="#01687D" x="14" y="9" width="1" height="1" rx="0.5"></rect> </g> <g id="guy" transform="translate(199.000000, 78.000000)"> <ellipse id="Oval-2-Copy-3" fill-opacity="0.200000003" fill="#01687D" cx="13" cy="67.5" rx="13" ry="3.5"></ellipse> <path d="M18,44 C19.2110104,48.764552 19.8776771,52.4312186 20,55 C20.1223229,57.5687814 19.4556563,60.9021147 18,65" id="Path-6" stroke="#01687D" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M9,44 L9,65" id="Path-6-Copy-2" stroke="#01687D" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.5,17 L13.5,17 L13.5,17 C17.6421356,17 21,20.3578644 21,24.5 L21,42.7193264 L21.0000159,42.7193264 C21.0000159,43.5502369 20.486266,44.2946007 19.7093765,44.5893126 C17.2302362,45.5297709 14.9937774,46 13,46 C11.0538809,46 9.10827679,45.5519824 7.16318763,44.6559473 L7.16318921,44.6559439 C6.45418117,44.3293285 6,43.6200471 6,42.8394255 L6,24.5 L6,24.5 C6,20.3578644 9.35786438,17 13.5,17 Z" id="Rectangle-13" fill="#01687D"></path> <path d="M13.5,19 L13.5,19 L13.5,19 C17.6421356,19 21,22.3578644 21,26.5 L21,40.1244836 L21,40.1244836 C21,40.6256862 20.6289697,41.0494707 20.1321637,41.1157115 L7.13216372,42.8490448 L7.13216372,42.8490448 C6.58472367,42.9220368 6.08176411,42.5374207 6.0087721,41.9899807 C6.00293046,41.9461684 6,41.902017 6,41.8578169 L6,26.5 L6,26.5 C6,22.3578644 9.35786438,19 13.5,19 Z" id="Rectangle-13" fill="#2EAA9B"></path> <path d="M13,17 L14,17 L14,17 C19.5228475,17 24,21.4771525 24,27 L24,29.4521135 L24,29.4521135 C24,33.8179793 20.8666108,37.5541911 16.5674694,38.3145646 L15.5284982,38.4983236 L7,40 L6.56173762,40.547828 L6.56173762,40.547828 C5.87171852,41.4103518 4.61313378,41.5501946 3.7506099,40.8601755 C3.27617944,40.4806311 3,39.9060053 3,39.2984379 L3,27 L3,27 C3,21.4771525 7.4771525,17 13,17 Z" id="Rectangle-13" fill="#2EAA9B"></path> <path d="M13.5,34 L14.0574682,33.6283545 L14.0574682,33.6283545 C14.5169969,33.3220021 15.1378663,33.4461759 15.4442187,33.9057046 C15.4672194,33.9402056 15.4880519,33.9761038 15.5065956,34.0131912 L17,37 L15.7102631,37.4299123 L15.7102631,37.4299123 C14.7005104,37.7664965 13.5904078,37.3856118 13,36.5 L13,36.5 L13,36.5 C12.4477153,35.6715729 12.6715729,34.5522847 13.5,34 Z" id="Rectangle-20" fill="#DDF0EC"></path> <path d="M13.5,1 L13.5,1 L13.5,1 C17.0898509,1 20,3.91014913 20,7.5 L20,12 L20,12 C20,14.209139 18.209139,16 16,16 L11,16 L11,16 C8.790861,16 7,14.209139 7,12 L7,7.5 L7,7.5 C7,3.91014913 9.91014913,1 13.5,1 Z" id="Rectangle-16" fill="#DDF0EC"></path> <path d="M14,0 L18,0 L18,2 L18,2 C18,3.65685425 16.6568542,5 15,5 L9,5 L9,5 L9,5 C9,2.23857625 11.2385763,5.07265313e-16 14,0 Z" id="Rectangle-16" fill="#01687D"></path> <rect id="Rectangle-17" fill="#01687D" x="10" y="9" width="1" height="1" rx="0.5"></rect> <rect id="Rectangle-17-Copy" fill="#01687D" x="16" y="9" width="1" height="1" rx="0.5"></rect> </g> <text id="" font-family="FontAwesome" font-size="16" font-weight="normal" line-spacing="23" fill="#2EAA9B"> <tspan x="203" y="220"></tspan> </text> <text id="-copy" font-family="FontAwesome" font-size="16" font-weight="normal" line-spacing="23" fill="#2EAA9B"> <tspan x="109" y="259"></tspan> </text> <text id="" font-family="FontAwesome" font-size="16" font-weight="normal" line-spacing="23" fill="#A4B3C7"> <tspan x="45.7142857" y="56"></tspan> </text> <text id="-copy" font-family="FontAwesome" font-size="16" font-weight="normal" line-spacing="23" fill="#A4B3C7"> <tspan x="134.714286" y="52"></tspan> </text> <text id="-copy-2" font-family="FontAwesome" font-size="16" font-weight="normal" line-spacing="23" fill="#A4B3C7"> <tspan x="207.714286" y="66"></tspan> </text> <text id="-copy-3" font-family="FontAwesome" font-size="16" font-weight="normal" line-spacing="23" fill="#A4B3C7"> <tspan x="95.7142857" y="72"></tspan> </text> </g> </g> </g> </g></svg>'
		};
	},
	outsideClick: function (e) {
		var self = this;
		var sidebarTrigger = document.getElementById('change-segment-status-sidebar');
		// If dropdown is open and click was not in/on trigger/dropdown
		if (
			self.props.cogOpen &&
			self._dropdown &&
			!self._dropdown.contains(e.target) &&
			self._dropdownTrigger !== e.target &&
			!self._dropdownTrigger.contains(e.target) &&
			(!sidebarTrigger || (sidebarTrigger && sidebarTrigger !== e.target && !sidebarTrigger.contains(e.target)))
		) {
			self.props.editDropdown();
		}
	},
	componentDidMount: function () {
		document.addEventListener('click', this.outsideClick);
	},
	componentWillUnmount: function () {
		document.removeEventListener('click', this.outsideClick);
	},
	tabGoTo: function (state) {
		Tools.$state.go(state, {});
	},
	settingsDropdown: function (active) {
		var self = this;

		var itemArray = [];
		if (!active) {
			itemArray.push({
				key: 'activate-segment',
				class: 'item green',
				icon: 'fa fa-play',
				title: T('segment.settings.activate.title'),
				desc: T('segment.settings.activate.desc'),
				onClick: function () {
					self.props.editDropdown();
					self.props.activateSegment();
				}
			});
		} else {
			itemArray.push({
				key: 'archive-segment',
				class: 'item',
				icon: 'fa fa-archive',
				title: T('segment.settings.archive.title'),
				desc: T('segment.settings.archive.desc'),
				onClick: function () {
					self.props.editDropdown();
					self.props.archiveSegment();
				}
			});
		}

		itemArray.push({
			key: 'copy-segment',
			class: 'item',
			icon: 'fa fa-copy',
			title: T('segment.copy'),
			desc: T('segment.copyDescription'),
			onClick: () => self.props.actions.copySegment()
		});

		itemArray.push({
			key: 'edit-segment',
			class: 'item',
			icon: 'fa fa-edit',
			title: T('segment.settings.edit.title'),
			desc: T('segment.settings.edit.desc'),
			onClick: function () {
				self.props.editDropdown();
				self.props.actions.editSegment();
			}
		});

		itemArray.push({
			key: 'remove-segment',
			class: 'item',
			icon: 'fa fa-trash-o',
			title: T('segment.settings.remove.title'),
			desc: T('segment.settings.remove.desc'),
			onClick: function () {
				self.props.editDropdown();
				self.props.delete();
			}
		});

		var canExport = AppService.getSelf().export;

		itemArray.push({
			key: 'export-segment',
			class: canExport ? 'item' : 'item disabled',
			icon: 'fa fa-file-excel-o',
			title: T('segment.settings.export.title'),
			desc: canExport ? T('segment.settings.export.desc') : T('default.noExportRights'),
			onClick: function () {
				if (canExport) {
					self.props.editDropdown();
					self.props.export();
				}
				return;
			}
		});

		if (self.props.flowComponent.flow) {
			var flowItem = self.props.flowComponent.flow;

			itemArray.unshift({
				type: 'subtitle',
				text: T('segment.segment') + ' ' + T('settings')
			});

			itemArray.push(
				{
					type: 'subtitle',
					text: T('flow.flowSettings')
				},
				{
					key: 'duplicate-flow',
					class: 'item',
					icon: 'fa fa-copy',
					title: T('flow.settings.duplicate.title'),
					desc: T('flow.settings.duplicate.desc'),
					onClick: function () {
						self.props.editDropdown();
						self.props.actions.copyFlow(flowItem);
					}
				},
				{
					key: 'edit-flow',
					class: 'item',
					icon: 'fa fa-edit',
					title: T('flow.settings.edit.title'),
					desc: T('flow.settings.edit.desc'),
					onClick: function () {
						self.props.editDropdown();
						self.props.actions.editFlow(flowItem);
					}
				},
				{
					key: 'remove-flow',
					class: 'item',
					icon: 'fa fa-trash-o',
					title: T('flow.settings.remove.title'),
					desc: T('flow.settings.remove.desc'),
					onClick: function () {
						self.props.editDropdown();
						self.props.actions.deleteFlow(flowItem);
					}
				}
			);
		}

		return (
			<ul className={self.props.flowComponent.flow !== null ? 'flowVisible' : null}>
				{_.map(itemArray, function (item) {
					if (item.type && item.type === 'subtitle') {
						return (
							<li className="segment-dropdown-subtitle" key={'subtitle-' + item.text}>
								{item.text}
							</li>
						);
					}

					return (
						<li data-test-id={'segment-edit-' + item.key} key={item.key} onClick={item.onClick}>
							<div className={item.class}>
								<div className="icon">
									<i className={item.icon} />
								</div>
								<div className="text">
									<span>{item.title}</span>
									<span>{item.desc}</span>
								</div>
							</div>
						</li>
					);
				})}
			</ul>
		);
	},
	render: function () {
		var self = this;

		var content;

		if (self.props.activeTab === 'events') {
			self.props.activeTab = 'contacts';
		}

		var className = self.props.segment.version === 2 ? 'segment-v2' : 'segment-v1';
		className = `${className} ${className}--noFrame`;

		switch (self.props.activeTab) {
			case 'contacts':
				content = (
					<div className={className}>
						{self.props.segment.version === 2
							? React.createElement(FilterContainer, self.props)
							: React.createElement(ReactTemplates.segment.filters, self.props)}
						{React.createElement(ReactTemplates.segment.contacts, self.props)}
					</div>
				);
				break;
			case 'mailcampaign':
				content = React.createElement(ReactTemplates.segment.mailcampaign, self.props);
				break;
			case 'events':
				content = (
					<div id="segment-body">
						{React.createElement(ReactTemplates.segment.contactStats, self.props)}
						{React.createElement(ReactTemplates.segment.events, self.props)}
					</div>
				);
				break;
			case 'flow':
				content = React.createElement(ReactTemplates.segment.flowPreview, self.props);
				break;
		}

		var events = _.map(self.props.segment.stats.byMonth, function (event) {
			return event.events;
		});

		if (
			self.props.activeTab === 'contacts' &&
			!self.props.segment.filter.length &&
			self.props.segment.version === 1
		) {
			content = (
				<div className="filter-onboarding">
					<div className="svg-block" dangerouslySetInnerHTML={this.createSVG()} />
					<div className="text-block">
						<h2>{self.lang.nothingToSee_contacts_title}</h2>
						<p>
							<span className="ingress">{self.lang.nothingToSee_contacts_desc1}</span>
							{self.lang.nothingToSee_contacts_desc2}
						</p>

						<button
							className="btn up-btn no-shadow btn-block btn-lg"
							onClick={function () {
								self.props.filterComponent.addFilter();
							}}
							data-test-id="editsegment-onboarding-makeselection"
						>
							{self.lang.nothingToSee_buttonTxt}
						</button>
					</div>
				</div>
			);
		}

		if (self.props.activeTab === 'events' && _.flatten(events).length === 0 && self.props.totalContacts === 0) {
			content = (
				<div className="nothing-to-see-wrapper">
					<h2>{self.lang.nothingToSee_title}</h2>
					<p>{self.lang.nothingToSee_description}</p>
					<button
						onClick={function () {
							self.props.filterComponent.addFilter();
						}}
						className="btn up-btn"
					>
						{self.lang.nothingToSee_buttonTxt}
					</button>
				</div>
			);
		}

		var dropDown = self.settingsDropdown(self.props.segment.active, self.props.segment.id);

		var segmentFlowTabProps = {
			id: 'segment.flow',
			key: 'segment.flow',
			title: self.lang.flows
		};

		if (self.props.flowComponent && self.props.flowComponent.flow) {
			segmentFlowTabProps.className =
				'special-subtitle-class special-subtitle-' + self.props.flowComponent.flow.status;
			segmentFlowTabProps.subtitle = T('flow.statuses.' + self.props.flowComponent.flow.status);
		} else {
			segmentFlowTabProps.subtitle = T('flow.noFlow');
		}

		const tabArray = [<Tab id="segment.contacts" key="segment.contacts" title={self.lang.contacts} />];

		if (isAvailable(Feature.GROUP_MAIL)) {
			tabArray.push(
				<Tab
					id="segment.mailCampaign"
					key="segment.mailCampaign"
					title={self.lang.mailcampaign}
					subtitle={numberFormat(self.props.segment.stats.mailCount) + ' ' + T('event.sent').toLowerCase()}
				/>
			);
		}

		if (isAvailable(Feature.FLOW)) {
			tabArray.push(<Tab {...segmentFlowTabProps} />);
		}

		return (
			<div id="edit-segment-body" className={self.props.segment.version === 2 ? 'version-2' : ''}>
				<div className="navigation-bar">
					<ul className="nav">
						<BouncingTooltip
							title={self.lang.selectionTooltip}
							direction="top"
							iterationCount={'infinite'}
							distance={20}
							dissmisable={true}
							visible={self.props.flowComponent.showSelectionTooltip && self.props.activeTab === 'flow'}
							onHide={() => {
								self.props.flowComponent.hideSelectionTooltip();
							}}
						>
							{makeTooltipDisappear => (
								<Tabs
									onChange={value => {
										makeTooltipDisappear();
										self.tabGoTo(value);
									}}
									align="left"
									noFlex={true}
									selected={
										self.props.activeTab === 'mailcampaign'
											? 'segment.mailCampaign'
											: 'segment.' + self.props.activeTab
									}
								>
									{tabArray}
								</Tabs>
							)}
						</BouncingTooltip>
						<li className="nav-tools">
							<a
								ref={function (r) {
									self._dropdownTrigger = r;
								}}
								data-test-id="segment-nav-edit"
								className="nav-a"
								onClick={self.props.editDropdown}
							>
								<b className="fa fa-cog" />
							</a>
							<div
								ref={function (r) {
									self._dropdown = r;
								}}
								className={self.props.cogOpen ? 'settings-dropdown open' : 'settings-dropdown'}
							>
								{dropDown}
							</div>
						</li>
					</ul>
				</div>

				{content}
			</div>
		);
	}
});
